import React from 'react'
import DatabaseConnection from './database-connection'
import Questions from './questions'
import Contacts from '../contacts-block'

export const Help: React.FC = (props) => {
  return (
    <>
      <DatabaseConnection />
      <Questions />
      <Contacts />
    </>
  )
}

export default Help
